// TODO:之後整理 view_dr開頭的 api
import defaultApi from '@/utils/request';

export default {
  // 學制
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 'view_dr_yms/Load',
      params,
    });
  },
  // 系所
};
